import './ProductDetails.scss';

import { useDevice } from '@/resources/hooks/useDevice';
import { IProduct } from '@/store/ducks/products/types';

import { DesktopDetails } from './desktopDetails';
import { MobileDetails } from './mobileDetails';

interface ProductDetailsProps {
  product: IProduct;
}

export function ProductDetails({ product }: ProductDetailsProps) {
  const { device } = useDevice();

  return device === 'mobile' ? (
    <MobileDetails product={product} />
  ) : (
    <DesktopDetails product={product} />
  );
}
